import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  updateAlertStatus,
  updateConfigurationValue,
  updateDownloadConciegeAlertStatus,
} from '../../store/actions/onboarding';
import { sendAmplitudeEvents } from '../../utils/common';
import { EventNames } from '../../utils/events';
import {
  conciergeDownloadLink,
  getFrameworkConfiguration,
  getTestRunnerCmd,
  getShellOption,
} from '../../utils/onboarding/languageBasedConfig';
import { getFrameworkConfigurationLinux } from '../../utils/onboarding/languageBasedConfigLinux';

const queryString = require('query-string');

const useOnboardingConfiguration = () => {
  const dispatch = useDispatch();

  const userInfo = useSelector((state) => state.userInfo?.userInfo);
  const visual = useSelector((state) => state.onboarding?.visual);
  const currentConfiguration = useSelector(
    (state) => state.onboarding?.currentConfiguration
  );

  let currentFramework = currentConfiguration.frameworkConfiguration;

  const [textCopiedType, setTextCopiedType] = useState('');
  const [currentSetupTab, setCurrentSetupTab] = useState(0);
  const [yamlCopied, setYamlCopied] = useState(false);
  const [yamlDownloaded, setYamlDownloaded] = useState(false);
  const [currentYamlOsSelection, setCurrentYamlOsSelection] = useState(0);

  let systemOS = 'win';
  if (window.navigator.platform.indexOf('Win') !== -1) {
    systemOS = 'win';
  } else if (window.navigator.platform.indexOf('Mac') !== -1) {
    systemOS = 'mac';
  } else if (window.navigator.platform.indexOf('Linux') !== -1) {
    systemOS = 'linux';
  }

  function getSystemOsName(osName) {
    let platformName = osName ? osName : systemOS;
    switch (platformName) {
      case 'win':
        return 'Windows';
      case 'mac':
        return 'MacOS';
      case 'linux':
        return 'Linux';
      default:
        return '';
    }
  }

  function getSystemOsIcon(osName) {
    let platformName = osName ? osName : systemOS;
    switch (platformName) {
      case 'win':
        return 'onboard/windows';
      case 'mac':
        return 'onboard/macos';
      case 'linux':
        return 'onboard/linux';
      default:
        return '';
    }
  }

  function getOthersOS() {
    switch (systemOS) {
      case 'win':
        return ['mac', 'linux'];
      case 'mac':
        return ['win', 'linux'];
      case 'linux':
        return ['win', 'mac'];
      default:
        return [];
    }
  }

  function handleLanguageClick(e, framework) {
    e.preventDefault();
    let completedSteps = [...currentConfiguration.completedSteps, 2];
    dispatch(
      updateConfigurationValue({
        framework: framework,
        completedSteps: completedSteps,
        currentStep: 3,
      })
    );
  }

  function setupProjectDownload(type) {
    let completedSteps = [...currentConfiguration.completedSteps, 1];
    dispatch(
      updateConfigurationValue({
        projectSetup: type,
        completedSteps: completedSteps,
        currentStep: 2,
      })
    );
    if (type === 'zip') {
      sendAmplitudeEvents(EventNames.HYP_ONBOARDING_DOWNLOAD_REPO_SAMPLE, {
        'code sample': currentFramework.setupGit.downloadZip,
      });
      window.open(currentFramework.setupGit.downloadZip, '_blank').focus();
    } else {
      sendAmplitudeEvents(EventNames.HYP_ONBOARDING_GIT_CLONE_SAMPLE, {
        copied: currentFramework?.setupGit?.clone,
      });
    }
  }

  useEffect(() => {
    let parsed = queryString.parse(window.location.search);
    let platform = 'win';
    if (window.navigator.platform.indexOf('Win') !== -1) {
      platform = 'win';
    } else if (window.navigator.platform.indexOf('Mac') !== -1) {
      platform = 'mac';
    } else if (window.navigator.platform.indexOf('Linux') !== -1) {
      platform = 'linux';
    }
    dispatch(
      updateConfigurationValue({
        conciergePlatform: platform,
      })
    );
    let urlSegments = window.location.pathname.split('/');
    let langConfig = getFrameworkConfiguration(
      urlSegments[urlSegments.length - 1],
      parsed && parsed.frameworkType
    );
    dispatch(
      updateConfigurationValue({
        framework: {
          ...currentConfiguration.framework,
          name: urlSegments[urlSegments.length - 1],
        },
        frameworkConfiguration: langConfig,
        frameworkType: parsed && parsed.frameworkType,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function setConciergePlatform(type) {
    dispatch(
      updateConfigurationValue({
        conciergePlatform: type,
      })
    );
  }

  function setPlatform(type) {
    let completedSteps = [...currentConfiguration.completedSteps, 3];
    dispatch(
      updateConfigurationValue({
        platform: type,
        completedSteps: completedSteps,
        // currentStep: 4,
      })
    );
  }

  function getConciergeURL(type) {
    let conciergeUrl = '';
    if (type === 'mac') {
      conciergeUrl = conciergeDownloadLink.mac;
    } else if (type === 'linux') {
      conciergeUrl = conciergeDownloadLink.linux;
    } else if (type === 'win') {
      conciergeUrl = conciergeDownloadLink.windows;
    }
    return conciergeUrl;
  }

  function downloadConcierge(type) {
    // let conciergeUrl = '';
    // if (type === 'mac') {
    //   conciergeUrl = conciergeDownloadLink.mac;
    // } else if (type === 'linux') {
    //   conciergeUrl = conciergeDownloadLink.linux;
    // } else if (type === 'win') {
    //   conciergeUrl = conciergeDownloadLink.windows;
    // }
    setConciergePlatform(type);
    // window.open(conciergeUrl, '_blank');
    let completedSteps = [...currentConfiguration.completedSteps, 2];
    dispatch(
      updateConfigurationValue({
        completedSteps: completedSteps,
        currentStep: 3,
      })
    );
    if (type !== 'win') {
      dispatch(updateDownloadConciegeAlertStatus(true));
    } else {
      // for window , downt show popup
      dispatch(updateDownloadConciegeAlertStatus(false));
    }
    sendAmplitudeEvents(
      EventNames.HYP_ONBOARDING_HYPEREXECUTE_CLI_DOWNLOAD_SAMPLE,
      {
        os: type,
      }
    );
  }

  function getCommandToRunTest() {
    let command = currentFramework.runTestCommand;
    let conciergeBasedOnOs = './hyperexecute';

    switch (currentConfiguration.conciergePlatform) {
      case 'win':
        conciergeBasedOnOs = 'hyperexecute.exe';
        break;
      case 'mac':
      case 'linux':
        conciergeBasedOnOs = './hyperexecute';
        break;
      default:
        break;
    }

    let config = '<your_yaml_file_name>';

    if (yamlDownloaded) {
      config = 'hyperexecute.yaml';
    }

    let mapObj = {
      USERNAME: userInfo && userInfo.data && userInfo.data.username,
      ACCESSKEY: userInfo && userInfo.data && userInfo.data.apiToken,
      CONCIERGE: conciergeBasedOnOs,
      CONFIG: config,
    };
    command = command.replace(
      /USERNAME|ACCESSKEY|CONCIERGE|CONFIG/g,
      function (matched) {
        return mapObj[matched];
      }
    );
    return command;
  }

  function getYamlCode() {
    let currentFrameWorkName =
      currentConfiguration &&
      currentConfiguration.framework &&
      currentConfiguration.framework.name;
    let framework = getFrameworkConfiguration(
      currentFrameWorkName,
      currentConfiguration.frameworkType
    );
    let yamlCode = framework.yamlCode;
    if (currentConfiguration.platform === 'linux') {
      yamlCode = getFrameworkConfigurationLinux(
        currentFrameWorkName,
        currentConfiguration.frameworkType
      ).yamlCode;
    }
    let shellOption = getShellOption(
      currentConfiguration.platform,
      currentFrameWorkName
    );
    let testRunnerCmd = getTestRunnerCmd(
      currentConfiguration.platform,
      currentFrameWorkName,
      currentConfiguration.frameworkType
    );
    let mapObj = {
      PLATFORM: currentConfiguration.platform,
      SHELL_OPTION: shellOption,
      TEST_RUNNER: testRunnerCmd,
    };
    yamlCode = yamlCode.replace(
      /PLATFORM|SHELL_OPTION|TEST_RUNNER/g,
      function (matched) {
        return mapObj[matched];
      }
    );
    return yamlCode;
  }

  function copyBtnClicked(type) {
    setTextCopiedType(type);
    setTimeout(() => {
      setTextCopiedType('');
    }, 1000);
    if (type === 'yaml') {
      setYamlCopied(true);
      setYamlDownloaded(false);
      updateYamlCopyAlertStatus({
        yamlCodeCopiedAlert: true,
        yamlCodeDownloadedAlert: false,
      });
      updateCompletedSteps(3, 4);
    }
  }

  function downloadYaml(text) {
    var a = document.createElement('a');
    document.body.appendChild(a);
    a.style = 'display: none';

    var json = text;
    var blob = new Blob([json], { type: 'octet/stream' });
    var url = window.URL.createObjectURL(blob);
    //window.location.assign(url);
    a.href = url;
    a.download = 'hyperexecute.yaml';
    a.click();
    window.URL.revokeObjectURL(url);
    setYamlCopied(false);
    setYamlDownloaded(true);
    updateYamlCopyAlertStatus({
      yamlCodeDownloadedAlert: true,
      yamlCodeCopiedAlert: false,
    });
    updateCompletedSteps(3, 4);
  }

  function updateCompletedSteps(completedStep, currentStep) {
    let completedSteps = [
      ...currentConfiguration.completedSteps,
      completedStep,
    ];
    dispatch(
      updateConfigurationValue({
        currentStep: currentStep,
        completedSteps: completedSteps,
      })
    );
  }

  function updateYaml(yamlCode) {
    dispatch(
      updateConfigurationValue({
        frameworkConfiguration: {
          ...currentConfiguration.frameworkConfiguration,
          yamlCode: yamlCode,
        },
      })
    );
  }

  function platformChange(index) {
    setCurrentYamlOsSelection(index);
    let os = 'win';
    if (index === 0) {
      os = 'win';
    } else if (index === 1) {
      os = 'linux';
    }
    setPlatform(os);
  }

  function resetDownloadCociergeAlert() {
    dispatch(updateDownloadConciegeAlertStatus(false));
  }

  function updateYamlCopyAlertStatus(status) {
    dispatch(updateAlertStatus(status));
  }

  function handleViewInGithub(githubLink) {
    return () => {
      window.open(githubLink, '_blank');
      sendAmplitudeEvents(EventNames.HYP_ONBOARDING_VIEW_IN_GITHUB, {
        page_url: githubLink,
      });
    };
  }

  return {
    copyBtnClicked,
    currentConfiguration,
    currentFramework,
    currentSetupTab,
    currentYamlOsSelection,
    downloadConcierge,
    downloadYaml,
    getCommandToRunTest,
    getConciergeURL,
    getOthersOS,
    getSystemOsIcon,
    getSystemOsName,
    getYamlCode,
    handleLanguageClick,
    handleViewInGithub,
    platformChange,
    resetDownloadCociergeAlert,
    setConciergePlatform,
    setCurrentSetupTab,
    setPlatform,
    setTextCopiedType,
    setupProjectDownload,
    systemOS,
    textCopiedType,
    updateCompletedSteps,
    updateYaml,
    updateYamlCopyAlertStatus,
    userInfo,
    visual,
    yamlCopied,
    yamlDownloaded,
  };
};

export default useOnboardingConfiguration;
